import React, { useEffect, useState } from "react";
import { getLevelIncomeListApi } from "../utils/apiHandlers";
import { useSelector } from "react-redux";
import Pagination from "../components/Pagination";

const LevelIncome = () => {
  const { jwt } = useSelector((state) => state.wallet);
  const [incomeList, setincomeList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  function fetchList(p) {
    setLoading(true);
    getLevelIncomeListApi(jwt, p) // you can pass page and limit also, (address,page,limit)
      .then((res) => {
        if (res) {
          // console.log(res);
          if (res.status == 200) {
            setincomeList(res?.data);
            setPage(res?.page);
          } else {
            setincomeList([]);
          }
          //console.log(res?.data);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.log(e);
      });
  }

  useEffect(() => {
    fetchList(page);
  }, []);
  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="mb-2">
            <h5 className="mb-0">Level Income</h5>
          </div>
          <div className="table-responsive">
            <table className="table border table-striped table-bordered text-nowrap">
              <thead className="thead-dark">
                <tr>
                  {/* Replace these headers with your actual data keys */}
                  <th>S.no</th>
                  <th>From User</th>
                  {/* <th>Level</th> */}
                  {/* <th>Amount</th> */}
                  {/* <th>Total</th> */}
                  {/* <th>Rate</th> */}
                  <th>Income Type</th>
                  <th>Recieved At</th>
                </tr>
              </thead>
              <tbody>
                {incomeList?.length &&
                  incomeList?.map((referral, index) => (
                    <tr key={index + "lincmlist"}>
                      <td>{index + 1}</td>
                      <td>{referral?.from}</td>
                      {/* <td>{referral?.level + 1}</td> */}
                      {/* <td>{referral?.amount}</td> */}
                      {/* <td>{referral?.total}</td> */}
                      {/* <td>{referral?.rate}</td> */}
                      <td>{referral?.type}</td>
                      <td>
                        {new Date(
                          referral?.timestamp * 1000
                        ).toLocaleDateString()}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <Pagination
              page={page}
              callback={(p) => {
                if (!loading) fetchList(p);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LevelIncome;
